export const isPlaywright = () => {
  return globalThis.isPlaywright !== undefined && !!globalThis.isPlaywright
}
